import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import ModalCloseButton from '~/components/buttons/ModalCloseButton';
import PrimaryButton from '~/components/buttons/PrimaryButton';
import Modal from '~/components/modals/Modal';
import DatePicker from '../../../../components/fields/DatePicker';
import InputPicker from '../../../../components/fields/InputPicker';
import FocusTrap from '../../../../components/layout/FocusTrap';
import { compareDatesGT, getToday, validateYear, } from '../../../../services/date-time.service';
import { initCreateModalState } from '../services/attendance.services';
import { modalReducer } from '../services/modal.reducer';
const CreateAttendanceModal = ({ closeModal, submitHandler }) => {
    const today = getToday();
    const [modalState, dispatchModalState] = useReducer(modalReducer, initCreateModalState);
    useEffect(() => {
        dispatchModalState({
            type: 'FOCUS_STATE',
            id: 'workshopName',
        });
    }, []);
    const submitOnClick = () => {
        if (validateModal())
            submitHandler({
                type: 'TRAINING',
                hours: Number(modalState.fields.hours.value),
                name: modalState.fields.workshopName.value,
                startDate: modalState.fields.startDate.value,
                endDate: modalState.fields.endDate.value,
                comments: modalState.fields.comments.value,
            });
    };
    const validateModal = () => {
        const inValidFields = [];
        if (modalState.fields.workshopName.value == '') {
            inValidFields.push('workshopName');
        }
        if (!validateYear(modalState.fields.startDate.value) ||
            !validateDate(modalState.fields.startDate.value) ||
            modalState.fields.startDate.value == '') {
            inValidFields.push('startDate');
        }
        if (!validateYear(modalState.fields.endDate.value) ||
            !validateDate(modalState.fields.endDate.value) ||
            modalState.fields.endDate.value == '') {
            inValidFields.push('endDate');
        }
        if (modalState.fields.hours.value <= 0) {
            inValidFields.push('hours');
        }
        if (inValidFields.length > 0) {
            dispatchModalState({
                type: 'FOCUS_STATE',
                id: inValidFields[0],
            });
            for (const id of inValidFields) {
                dispatchModalState({
                    type: 'UPDATE_IS_VALID',
                    id: id,
                    isValid: false,
                    message: '',
                });
            }
        }
        return !(inValidFields.length > 0);
    };
    const modalOnChange = (event) => {
        const { value, id } = event.target;
        dispatchModalState({
            type: 'UPDATE_VALUE',
            id: id,
            value: value,
        });
        if (modalState.fields[id].validate) {
            validateHandler(id, value);
        }
    };
    const validateHandler = (id, value) => {
        let result = true;
        let message = '';
        if (id == 'startDate') {
            if (value != '') {
                result = validateDate(value);
                if (!result)
                    message = 'Start date cannot be greater than today.';
            }
        }
        else if (id == 'endDate') {
            if (value != '') {
                result = validateDate(value);
                if (!result)
                    message = 'End date cannot be greater than today.';
            }
        }
        dispatchModalState({
            type: 'UPDATE_IS_VALID',
            id: id,
            isValid: result,
            message: message,
        });
    };
    const validateDate = (value) => {
        const today = new Date().toLocaleDateString();
        return !compareDatesGT(value, today);
    };
    return (_jsx(Modal, { children: _jsx(FocusTrap, { isActive: true, children: _jsx("div", { className: "fixed inset-0 z-10 flex items-center", children: _jsxs("div", { className: "relative m-auto flex w-full max-w-2xl flex-col justify-between overflow-auto rounded-lg bg-white shadow-md", children: [_jsxs("div", { className: "p-8", id: "modal-body", children: [_jsxs("div", { className: "flex items-center", children: [_jsx("div", { className: "m-3 mb-3 justify-start text-xl font-extrabold text-black", children: "Create Attendance" }), _jsx(ModalCloseButton, { onClick: closeModal })] }), _jsx("div", { className: "m-3 mb-3", children: _jsx(InputPicker, { focus: modalState.fields.workshopName.focus, inputIsValid: modalState.fields.workshopName.isValid, inputLabel: "Workshop Name", name: "workshopName", onChange: modalOnChange, required: true, titleClass: "font-medium", value: modalState.fields.workshopName.value }) }), _jsx("div", { className: "m-3 mb-3", children: _jsx(DatePicker, { errorText: modalState.fields.startDate.message, focus: modalState.fields.startDate.focus, inputIsValid: modalState.fields.startDate.isValid, inputLabel: "Start Date", max: today, name: "startDate", onChange: modalOnChange, required: true, titleClass: "font-medium", value: modalState.fields.startDate.value }) }), _jsx("div", { className: "m-3 mb-3", children: _jsx(DatePicker, { errorText: modalState.fields.endDate.message, focus: modalState.fields.endDate.focus, inputIsValid: modalState.fields.endDate.isValid, inputLabel: "End Date", max: today, name: "endDate", onChange: modalOnChange, required: true, titleClass: "font-medium", value: modalState.fields.endDate.value }) }), _jsx("div", { className: "m-3 mb-3", children: _jsx(InputPicker, { focus: modalState.fields.hours.focus, inputIsValid: modalState.fields.hours.isValid, inputLabel: "Hours", name: "hours", onChange: modalOnChange, required: true, step: ".01", titleClass: "font-medium", type: "number", value: modalState.fields.hours.value }) }), _jsxs("div", { className: "m-3 mb-3", children: [_jsx("label", { className: "font-medium", htmlFor: "hours-type", children: "Type" }), _jsx("span", { className: "p-2", children: "TRAINING" })] }), _jsxs("div", { className: "m-3 mb-3", children: [_jsx("label", { className: "font-medium", htmlFor: "password", children: "Comments" }), _jsx("textarea", { className: "block h-20 w-full rounded border-2 border-solid border-gray-100 bg-gray-100 p-2 text-cssText hover:bg-gray-200 focus:border-blue-500 focus:bg-white focus:text-black focus:outline-none", id: "comments", onChange: modalOnChange, value: modalState.fields.comments.value })] })] }), _jsx("div", { className: "flex justify-end p-4", style: { backgroundColor: '#F5F4F7' }, children: _jsx("span", { className: "m-2", children: _jsx(PrimaryButton, { onClick: submitOnClick, text: "Save" }) }) })] }) }) }) }));
};
export default CreateAttendanceModal;
